<template>
  <div class="bg-white">
    <div>
      <a-button type="primary" @click="newOrder">新订单</a-button>
      <a-button class="m-l-8" :loading="searching" @click="search" type="primary" ghost>刷新列表</a-button>
    </div>

    <div class="p-t-16">
      <Table :columns="columns" border :data="dataPages.content"></Table>
      <div class="text-r p-15">
        <Page :total="dataPages.totalElements" :current="dataPages.number+1" show-elevator show-total
              :page-size="20" size="small" @on-change="search"></Page>
      </div>
    </div>

    <Modal v-model="modal.show" @on-ok="ok" ok-text="确定">
      <p class="m-t-20 text-c">资料补充已完成</p>
      <p class="m-t-10 m-b-10 text-c">将资料重新提交给刻章店</p>
    </Modal>
  </div>
</template>

<script>
  import Vue from 'vue'
  import store from '@/modules'
  import pages from '@tubo/tubo-base/mixins/mixinPages'
  import {api} from '@/libs'

  export default {
    mixins: [pages],
    data() {
      let that = this
      return {
        columns: [
          {title: '申请单位名称', key: 'name'},
          {
            title: '刻章企业',
            tooltip: true,
            render: (h, w) => h('div', w.row.company ? w.row.company.name : '--')
          },
          {
            title: '印章数量',
            width: 85,
            render: (h, w) => h('div', w.row.sealCount)
          },
          {
            title: '总价',
            width: 90,
            render: (h, w) => h('div', Vue.filter('currency')(w.row.totalPrice))
          },
          {
            title: '订单状态',
            width: 85,
            render: (h, w) => {
              let arr = []
              if (w.row.notesIncomplete && w.row.notesIncomplete !== '') arr.push(h('span', {'class': 'c-red'}, '存在问题'))
              else arr.push(h('span', {
                directives: [{
                  name: 'dict',
                  value: w.row.orderState,
                  arg: 'EntityGzwOrder_orderState'
                }]
              }))
              return arr
            }
          },
          {
            title: '订单类型',
            width: 100,
            render: (h, w) => h('span', {
              directives: [{
                name: 'dict',
                value: w.row.orderType,
                arg: 'EntityGzwOrder_orderType'
              }]
            })
          },
          {
            title: '操作',
            width: 160,
            render: (h, w) => {
              const btns = []
              // if (w.row.notesIncomplete && w.row.notesIncomplete !== '') {
              //   btns.push(h('Button', {
              //     props: {type: 'primary', ghost: true, size: 'small'}, style: {marginRight: '5px'},
              //     on: {
              //       click: () => {
              //         this.modal.show = true;
              //         this.nowOrder = w.row
              //       }
              //     }
              //   }, '补充完成'))
              // }
              // if (w.row.orderState < 2) {
              //   btns.push(h('Button', {
              //     props: {type: 'primary', ghost: true, size: 'small'}, style: {marginRight: '5px'},
              //     on: {
              //       click: () => {
              //         this.$router.push({
              //           path: '/custom/order/new',
              //           query: {id: w.row.id}
              //         })
              //       }
              //     }
              //   }, w.row.orderState === '1' ? '修改' : '继续填报'))
              // }
              if (w.row.orderState === '0') {
                btns.push(h('Button', {
                  props: {type: 'primary', ghost: true, size: 'small'}, style: {marginRight: '5px'},
                  on: {
                    click: () => {
                      this.$router.push({
                        path: '/custom/order/new',
                        query: {id: w.row.id}
                      })
                    }
                  }
                }, '继续填报'))
              }
              if (w.row.orderState > 0) {
                btns.push(h('Button', {
                  props: {type: 'primary', ghost: true, size: 'small'}, style: {marginRight: '5px'},
                  on: {
                    click: () => {
                      this.$router.push({
                        path: '/custom/order/show',
                        query: {id: w.row.id}
                      })
                    }
                  }
                }, '详情'))
              }
              if (w.row.orderState === '0') {
                btns.push(h('Button', {
                  props: {type: 'primary', ghost: true, size: 'small'}, style: {marginRight: '5px'},
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '删除订单',
                        content: '是否删除' + w.row.name + '公司的订单？',
                        onOk: () => {
                          store.dispatch('order/deleteOrder', w.row).then(that.deleteIndex(w.index))
                        }
                      })
                    }
                  }
                }, '删除'))
              }
              return h('div', btns)
            }
          }
        ],
        modal: {
          show: false
        }
      }
    },
    computed: {
    },
    methods: {
      ok() {
        Object.assign(this.nowOrder, {notesIncomplete: '', companyId: this.nowOrder.company.id})
        this.$store.dispatch('order/postNewEditOrder', {
          orderJson: this.nowOrder,
          id: this.nowOrder.id
        })
      },
      newOrder() {
        this.$router.push({path: '/custom/order/new'})
      }
    },
    created() {
      this.searchApi = api.gzwCusOrder.orderActive
    }
  }
</script>

<style scoped>

</style>